

    var PI2 = Math.PI * 2;
    module.exports = {
        normalizeRadian: function(angle) {
            angle %= PI2;
            if (angle < 0) {
                angle += PI2;
            }
            return angle;
        }
    };



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/contain/util.js
// module id = ABnm
// module chunks = 5